import request from '@apps-common/js-client/api/request';
import {PDA_ADMIN_V1_BASE_PATH as base} from '@account/config';

export const getCustomerAccounts = ({
  limit = 20,
  offset = 0,
  search = '',
  id,
  is_trial,
  status,
  sort,
}) => {
  const params = {limit, offset};
  if (id) params.id = id;
  else if (search) params.search = search;
  if (is_trial === true || is_trial === false) params.is_trial = is_trial;
  // Lifecycle filter: active (disabled_at IS NULL AND valid_to > now),
  // expired (valid_to <= now), or disabled. Omitted = all statuses.
  if (status) params.status = status;
  if (sort) params.sort = sort;

  return request
    .get(`${base}/customer-accounts/`, {params})
    .then(res => res.data);
};

export const getCustomerAccount = accountId =>
  request.get(`${base}/customer-accounts/${accountId}`).then(res => res.data);

// Emails the customer a summary of their CA-level products plus a link to the
// Allocate page. Backend defaults the recipient to the CA admin when
// recipientEmail is omitted; cc addresses must be @planet.com (enforced
// server-side). See pda-admin quota-instructions-email endpoint.
export const sendQuotaInstructionsEmail = ({
  accountId,
  recipientEmail,
  cc = [],
}) =>
  request
    .post(`${base}/customer-accounts/${accountId}/quota-instructions-email`, {
      ...(recipientEmail ? {recipient_email: recipientEmail} : {}),
      cc,
    })
    .then(res => res.data);

// Typeahead search. Unlike the list endpoint's `search` (name-only), this
// matches a pasted UUID or a name in one call and orders an exact ID match
// first. Mirrors getOrganizationAutosuggest, including the resultcount name
// the backend uses instead of limit.
export const getCustomerAccountAutosuggest = ({
  limit = 8,
  search = '',
  status,
} = {}) => {
  const params = {resultcount: limit, search};
  // Lifecycle filter, same values the list endpoint takes. Omitted = all
  // statuses, which is what the non-provisioning callers want.
  if (status) params.status = status;

  return request
    .get(`${base}/customer-accounts/autosuggest/`, {params})
    .then(res => res.data);
};
